interface SessionStatusTagsProps {
  going?: boolean;
  interested?: boolean;
}

/** Personal status chips on session board cards — going first, then interest. */
export function SessionStatusTags({ going, interested }: SessionStatusTagsProps) {
  if (!going && !interested) return null;

  return (
    <div className="flex flex-wrap items-center gap-1 mt-0.5">
      {going && (
        <span className="session-status-tag session-status-tag--going">
          <svg className="w-3 h-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" aria-hidden>
            <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z" />
          </svg>
          Going
        </span>
      )}
      {interested && (
        <span className="session-status-tag session-status-tag--interest">
          <svg className="w-3 h-3 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
          Interest
        </span>
      )}
    </div>
  );
}

interface SessionQuickBookmarkProps {
  bookmarked: boolean;
  onToggle: () => void;
  className?: string;
}

/** Top-right bookmark toggle on session board cards. */
export function SessionQuickBookmark({ bookmarked, onToggle, className = '' }: SessionQuickBookmarkProps) {
  return (
    <button
      type="button"
      className={`session-card-bookmark ${bookmarked ? 'session-card-bookmark--active' : ''} ${className}`.trim()}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      aria-pressed={bookmarked}
      aria-label={bookmarked ? 'Remove from going list' : 'Want to go to this session'}
      title={bookmarked ? 'Remove from going list' : 'Want to go to this session'}
    >
      <svg
        className="w-3.5 h-3.5"
        fill={bookmarked ? 'currentColor' : 'none'}
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
        />
      </svg>
    </button>
  );
}
